/**
 * CAFÉCLIC — boutons « Commander maintenant » :
 * sur une page produit, ils remontent au bloc produit au lieu de changer de page.
 */
document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const link = target.closest('[data-cc-scroll-product]');
  if (!link) return;

  const product = document.querySelector('.product-information');
  if (!product) return;

  event.preventDefault();
  const header = document.querySelector('#header-component');
  const offset = header ? header.getBoundingClientRect().height : 0;
  const top = product.getBoundingClientRect().top + window.scrollY - offset;
  window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
});
